import { FC } from 'react';
import { Box, HStack } from '@chakra-ui/react';

import {
  TaxForecastProfileMainActivityType,
  TaxForecastProfileSubActivityType,
} from '__generated__/GQL';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';

import { locales } from '../../locales';
import ActivityInfo from './ActivityInfo';

interface SubActivityCardProps {
  parent: {
    title: string;
    value: TaxForecastProfileMainActivityType;
  };
  value?: TaxForecastProfileSubActivityType;
  onChange: (value: TaxForecastProfileSubActivityType) => void;
}

const SubActivityCard: FC<SubActivityCardProps> = ({
  onChange,
  parent,
  value,
}) => {
  return (
    <SunshineCard.Group isActive>
      <SunshineCard title={parent.title} value={parent.value} variant="radio" />
      <SunshineCard.RadioGroup
        onChange={onChange}
        padding="space-16"
        value={value}
      >
        <Text fontWeight="weight-500" variant="primary">
          {locales.subActivity.question}
        </Text>
        <SunshineCard
          value={TaxForecastProfileSubActivityType.Selling}
          variant="radio"
        >
          <SunshineCard.Title>
            <HStack>
              <Box>{locales.subActivity.selling}</Box>

              <ActivityInfo type="SELLING" />
            </HStack>
          </SunshineCard.Title>
        </SunshineCard>

        <SunshineCard
          value={TaxForecastProfileSubActivityType.Service}
          variant="radio"
        >
          <SunshineCard.Title>
            <HStack>
              <Box>{locales.subActivity.service}</Box>

              <ActivityInfo type="SERVICE" />
            </HStack>
          </SunshineCard.Title>
        </SunshineCard>
      </SunshineCard.RadioGroup>
    </SunshineCard.Group>
  );
};

export default SubActivityCard;
